export interface Achievement {
  id: string;
  name: string;
  description: string;
  icon: string;
  points: number;
}

export const ACHIEVEMENTS: Record<string, Achievement> = {
  FIRST_LOGIN: {
    id: "first_login",
    name: "Primeiro Acesso",
    description: "Boas vindas ao Sinalário de Libras!",
    icon: "⭐",
    points: 5,
  },
  FIRST_WORD: {
    id: "first_word",
    name: "Primeira Palavra",
    description: "Visualizou sua primeira palavra",
    icon: "📖",
    points: 3,
  },
  FIRST_SEARCH: {
    id: "first_search",
    name: "Explorador",
    description: "Realizou sua primeira busca",
    icon: "🔍",
    points: 3,
  },
  FIRST_FAVORITE: {
    id: "first_favorite",
    name: "Favorito",
    description: "Adicionou seu primeiro favorito",
    icon: "❤️",
    points: 3,
  },
  WORD_MASTER_10: {
    id: "word_master_10",
    name: "Aprendiz",
    description: "Visualizou 10 palavras",
    icon: "🎓",
    points: 10,
  },
  WORD_MASTER_50: {
    id: "word_master_50",
    name: "Estudioso",
    description: "Visualizou 50 palavras",
    icon: "📚",
    points: 25,
  },
  WORD_MASTER_100: {
    id: "word_master_100",
    name: "Sábio",
    description: "Visualizou 100 palavras",
    icon: "🏆",
    points: 50,
  },
  SEARCH_MASTER_10: {
    id: "search_master_10",
    name: "Pesquisador",
    description: "Realizou 10 buscas",
    icon: "🕵️",
    points: 8,
  },
  SEARCH_MASTER_50: {
    id: "search_master_50",
    name: "Detetive",
    description: "Realizou 50 buscas",
    icon: "🔍",
    points: 20,
  },
  FAVORITE_MASTER_10: {
    id: "favorite_master_10",
    name: "Colecionador",
    description: "Adicionou 10 favoritos",
    icon: "💖",
    points: 8,
  },
  FAVORITE_MASTER_50: {
    id: "favorite_master_50",
    name: "Curador",
    description: "Adicionou 50 favoritos",
    icon: "💎",
    points: 20,
  },
  STREAK_7: {
    id: "streak_7",
    name: "Consistente",
    description: "7 dias seguidos de atividade",
    icon: "🔥",
    points: 15,
  },
  STREAK_30: {
    id: "streak_30",
    name: "Dedicado",
    description: "30 dias seguidos de atividade",
    icon: "⚡",
    points: 50,
  },
  LEVEL_5: {
    id: "level_5",
    name: "Iniciante",
    description: "Alcançou o nível 5",
    icon: "🌟",
    points: 15,
  },
  LEVEL_10: {
    id: "level_10",
    name: "Intermediário",
    description: "Alcançou o nível 10",
    icon: "✨",
    points: 30,
  },
  LEVEL_20: {
    id: "level_20",
    name: "Avançado",
    description: "Alcançou o nível 20",
    icon: "💫",
    points: 60,
  },
  FIRST_VIDEO: {
    id: "first_video",
    name: "Criador",
    description: "Enviou seu primeiro vídeo",
    icon: "🎥",
    points: 25,
  },
  VIDEO_MASTER_5: {
    id: "video_master_5",
    name: "Contribuidor",
    description: "Enviou 5 vídeos",
    icon: "🎬",
    points: 50,
  },
};
